import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import './FAQ.scss';

const faqData = [
  {
    category: "Inscription & Adhésion",
    items: [
      {
        question: "Comment m'inscrire à la Fondation BE TALENTED ?",
        answer: "Il vous suffit de cliquer sur le bouton « S'inscrire » en haut de la page, de remplir le formulaire avec vos informations personnelles et académiques, puis de valider. Un e-mail de confirmation vous sera envoyé immédiatement."
      },
      {
        question: "Qui peut s'inscrire à la Fondation BE TALENTED ?",
        answer: "Tout étudiant africain inscrit dans un établissement d'enseignement supérieur (université, école, BTS) peut rejoindre BE TALENTED. Nous accueillons les étudiants du niveau Licence 1 jusqu'au Doctorat."
      },
      {
        question: "L'inscription est-elle payante ?",
        answer: "L'inscription à la plateforme est gratuite. Certains programmes spécifiques peuvent nécessiter une contribution, mais celle-ci vous sera clairement indiquée avant toute démarche."
      },
      {
        question: "Je n'ai pas reçu mon e-mail de confirmation, que faire ?",
        answer: "Vérifiez votre dossier spam ou courriers indésirables. Si vous ne trouvez toujours rien après 5 minutes, contactez-nous à info@fondationbetalented.org en précisant votre adresse e-mail d'inscription."
      }
    ]
  },
  {
    category: "Nos Programmes",
    items: [
      {
        question: "Qu'est-ce que le programme CODE ?",
        answer: "CODE est un programme intensif de transformation du mindset. Il s'adresse aux étudiants ambitieux souhaitant développer leur solidité mentale, leur discipline personnelle et leur leadership. Les sessions ont lieu tous les 2 mois en ligne."
      },
      {
        question: "Comment fonctionne le programme TRAJECTOIRE ?",
        answer: "TRAJECTOIRE aide les étudiants à clarifier leur orientation académique et professionnelle. Chaque année, une filière est mise en lumière pour permettre aux étudiants de comprendre les métiers, compétences et débouchés de leur domaine."
      },
      {
        question: "À qui s'adresse PROPEL ?",
        answer: "PROPEL cible spécifiquement les étudiants ayant obtenu leur BTS, Licence ou Master. Ce programme de 3 jours intensifs prépare les diplômés à intégrer le monde professionnel avec posture, discipline et efficacité. Il inclut un stage de validation."
      },
      {
        question: "Puis-je m'inscrire à plusieurs programmes simultanément ?",
        answer: "Oui, tout à fait. Vous pouvez participer à plusieurs programmes selon votre niveau et vos objectifs. Votre dashboard vous permettra de suivre votre progression dans chacun d'eux."
      }
    ]
  },
  {
    category: "Espace Membre & Dashboard",
    items: [
      {
        question: "Que puis-je faire depuis mon tableau de bord ?",
        answer: "Votre dashboard vous donne accès à vos statistiques de progression (programmes suivis, formations complétées, certificats obtenus, mentorats actifs), vos activités récentes, vos événements à venir, ainsi que votre carte de membre téléchargeable."
      },
      {
        question: "Comment modifier mes informations de profil ?",
        answer: "Rendez-vous dans la section « Mon Profil » accessible depuis votre tableau de bord. Vous pouvez y modifier votre photo, vos informations personnelles, académiques et votre date de naissance."
      },
      {
        question: "Comment télécharger ma carte de membre ?",
        answer: "Depuis votre dashboard, cliquez sur le bouton « Télécharger ma carte » visible dans la section « Ma Carte de Membre ». La carte est générée automatiquement avec vos informations."
      }
    ]
  },
  {
    category: "Partenariats & Dons",
    items: [
      {
        question: "Comment devenir partenaire de BE TALENTED ?",
        answer: "Vous pouvez visiter notre page Partenaires et cliquer sur « Devenir Partenaire ». Nous acceptons les partenariats institutionnels, associatifs et d'entreprise. Notre équipe vous contactera dans les 48h."
      },
      {
        question: "Comment faire un don à la Fondation ?",
        answer: "Cliquez sur le bouton « Faire un Don » disponible dans la barre de navigation. Vous serez dirigé vers notre page de don sécurisée, qui propose plusieurs modes de paiement adaptés à l'Afrique (Orange Money, MTN Mobile Money, Wave)."
      }
    ]
  },
  {
    category: "Contact & Support",
    items: [
      {
        question: "Comment contacter la Fondation BE TALENTED ?",
        answer: "Vous pouvez nous joindre par e-mail à info@fondationbetalented.org, via notre formulaire de contact sur la page Contact, ou nous rendre visite à Cocody 2 Plateaux Cité AXA, Abidjan."
      },
      {
        question: "Quels sont les délais de réponse ?",
        answer: "Nous nous engageons à répondre à toutes les demandes sous 24 à 48 heures ouvrables."
      }
    ]
  }
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span>{question}</span>
        <svg className="faq-chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M6 9 L12 15 L18 9"/>
        </svg>
      </button>
      <div className="faq-answer">
        <p>{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  return (
    <div className="faq-page">
      <PageHeader
        title="FAQ"
        subtitle="Foire Aux Questions — Trouvez les réponses à vos questions"
        breadcrumb={['Accueil', 'FAQ']}
      />

      <div className="faq-container">
        <div className="faq-intro">
          <p>
            Vous avez des questions sur BE TALENTED, nos programmes ou votre espace membre ?
            Consultez les réponses ci-dessous. Si vous ne trouvez pas ce que vous cherchez, 
            n'hésitez pas à nous <Link to="/contact">contacter directement</Link>.
          </p>
        </div>

        {faqData.map((section, si) => (
          <div key={si} className="faq-section">
            <h2
              className={`faq-category ${activeCategory === si ? 'active' : ''}`}
              onClick={() => setActiveCategory(activeCategory === si ? null : si)}
            >
              <span>{section.category}</span>
              <span className="faq-count">{section.items.length} questions</span>
            </h2>
            <div className="faq-items">
              {section.items.map((item, ii) => (
                <FAQItem key={ii} question={item.question} answer={item.answer} />
              ))}
            </div>
          </div>
        ))}

        <div className="faq-cta">
          <h3>Vous n'avez pas trouvé votre réponse ?</h3>
          <p>Notre équipe est disponible pour répondre à toutes vos questions.</p>
          <Link to="/contact" className="faq-contact-btn">Nous contacter</Link>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
